const state = {
    isSidebarCollapsed: false,
    theme: 'dark',
};

const mutations = {
    TOGGLE_SIDEBAR(state) {
        state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    TOGGLE_THEME(state) {
        state.theme = state.theme === 'dark' ? 'light' : 'dark';
    }
};

const actions = {
    toggleSidebar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    toggleTheme({ commit }) {
        commit('TOGGLE_THEME');
    }
};

const getters = {
    isSidebarCollapsed: (state) => state.isSidebarCollapsed,
    theme: (state) => state.theme,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
